<template>
  <svg :width="width" :height="height" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M10.5 8C10.5 7.44771 10.9477 7 11.5 7H11.5511C12.1034 7 12.5511 7.44772 12.5511 8V12.496L15.0526 14.1568C15.5175 14.4654 15.6398 15.0949 15.3244 15.5552L15.3081 15.5789C14.9992 16.0298 14.3855 16.1491 13.9301 15.8467L10.5 13.5695L10.5056 13.5613H10.5V8Z"
      :fill="color"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M12 23C5.92487 23 1 18.0751 1 12C1 5.92487 5.92487 1 12 1C18.0751 1 23 5.92487 23 12C23 18.0751 18.0751 23 12 23ZM12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21Z"
      :fill="color"
    />
  </svg>
</template>

<script lang="ts">
export default {
  name: 'TimeOutlineIcon',
  props: {
    width: {
      type: Number,
      default: 24,
    },
    height: {
      type: Number,
      default: 24,
    },
    color: {
      type: String,
      default: '#99005c',
    },
  },
};
</script>
